import React from 'react';
import { CircularProgress, Typography, TextDescription, Alert, Scrollbar } from '@ann/web-components';
import {
  InstructionsContainer,
  InstructionWrapper,
  InstructionsHeader,
  TextDescriptionContainer,
  LoadingContainer,
} from './InstructionsPage.styled';
import { useInstructionsPage } from './hooks';

const InstructionsPage = () => {
  const {
    instruction,
    loading,
    error,
    showAlert,
    alertMessage,
    alertType,
    handleInstructionChange,
    handleCloseAlert,
  } = useInstructionsPage();

  if (loading) {
    return (
      <LoadingContainer>
        <CircularProgress size="xl" />
      </LoadingContainer>
    );
  }

  if (error) {
    return (
      <InstructionsContainer>
        <Typography category="body" size="medium" color="error">
          Error loading instructions. Please try again.
        </Typography>
      </InstructionsContainer>
    );
  }

  return (
    <>
      <Scrollbar size="small">
        <InstructionsContainer>
          <InstructionWrapper>
            <InstructionsHeader>
              <Typography category="subtitle" size="large" weight="bold">
                Builder
              </Typography>

              <Typography category="body" size="medium" weight="regular" color="body">
                Modify instructions anytime change them or delete them as needed.
              </Typography>
            </InstructionsHeader>

            <TextDescriptionContainer>
              <TextDescription
                expandable
                height="172px"
                label="Write Your Instruction"
                value={instruction}
                onChange={handleInstructionChange}
                placeholder="What will this agent do? How will they behave? What should they avoid doing?"
                size="medium"
              />
            </TextDescriptionContainer>
          </InstructionWrapper>
        </InstructionsContainer>
      </Scrollbar>

      {showAlert && (
        <Alert
          title=""
          description={alertMessage}
          severity={alertType}
          maxWidth="500px"
          closable={true}
          autoClose={true}
          autoCloseDelay={5000}
          onClose={handleCloseAlert}
        />
      )}
    </>
  );
};

export default InstructionsPage;

